'use client';

import { useEffect, useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { isQuizMuted, setQuizMuted } from '@/lib/utils/quizSounds';

/**
 * The speaker in the corner of a quiz card.
 *
 * It owns the mute state, because that state has exactly one reader — this
 * button — and every card that had its own copy also had to remember the
 * hydration dance: `isQuizMuted()` reads localStorage, so the server renders
 * unmuted and the client corrects once after mount. Two players did that by
 * hand; a third was about to.
 *
 * The setting itself is global (`quizSounds`), so muting here mutes the quiz on
 * a storefront, on the landing and in the case wall alike — one visitor, one
 * decision about sound.
 */
export function QuizMuteButton() {
  const [muted, setMuted] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMuted(isQuizMuted());
  }, []);

  return (
    <button
      type="button"
      onClick={() => {
        const next = !muted;
        setQuizMuted(next);
        setMuted(next);
      }}
      aria-label={muted ? 'Turn quiz sound on' : 'Turn quiz sound off'}
      aria-pressed={muted}
      className="mm-btn -mr-1 flex-shrink-0 rounded-full p-1.5 text-white/70"
    >
      {muted ? <VolumeX className="h-4 w-4" /> : <Volume2 className="h-4 w-4" />}
    </button>
  );
}
